import {filtro} from "@/servicios/hallazgos_auditoria/state";
import {getGeneralMonitorings} from "@/servicios/general_monitoring/actions";

export const defaultFilter = () => {
    return {
        company_id: null,
        slq_location_id: null,
        source_module: null,
        consecutive: null,
        state: null,
        date_report: null,
        is_report: null,
        wor_worker_id: null,
        page: 1,
        per_page: 10,
        sortBy: 'id',
        sort: 'DESC',
    }
}

export const defaultItemPayload = () => {
    return {
        company_id: null,
        slq_location_id: null,
        source_module: null,
        description: null,
        sys_user_id: null,
        concept: null,
        legislation: null,
        improvement_options: null,
        implement_percentage: 0,
        date_report: null,
        status: 'Creado',
        files: [],
        type: null,
    }
}

export const defaultPayload = () => {
    return [
        {
            company_id: null,
            slq_location_id: null,
            source_module: null,
            description: null,
            sys_user_id: null,
            concept: null,
            legislation: null,
            improvement_options: null,
            implement_percentage: 0,
            date_report: null,
            status: 'Creado',
            files: [],
            type: null,
        },
    ]
}

export const defaultGrmDetail = () => {
    return {
        id: null,
        source_module: "",
        description: "",
        concept: "",
        legislation: "",
        improvement_options: "",
        implement_percentage: 0,
        closing_date: null,
        created_at: "",
        company_id: null,
        slq_location_id: null,
        consecutive: "",
        state: "",
        grm_state_id: null,
        grm_states: []
    }
}

export default {
    filter: {
        company_id: null,
        slq_location_id: null,
        source_module: null,
        consecutive: null,
        state: null,
        date_report: null,
        is_report: null,
        wor_worker_id: null,
        page: 1,
        per_page: 10,
        sortBy: 'created_at',
        sort: 'DESC',
    },
    payload: [
        {
            company_id: null,
            slq_location_id: null,
            source_module: null,
            description: null,
            wor_worker_id: null,
            concept: null,
            legislation: null,
            improvement_options: null,
            implement_percentage: 0,
            date_report: null,
            status: 'Creado',
            files: [],
            type: null,
        },
    ],
    general_monitorings: [],
    grmDetail: defaultGrmDetail(),
    modules: [
        'INSPECCIONES',
        'AUDITORA INTERNA',
        'AUDITORIA EXTERNA',
        'REVISIÓN POR PARTE DE LA DIRECCION',
        'INVESTIGACIONES DE ACCIDENTES',
        'ANALISIS DE RIESGO',
    ],
    status_list: ['Creado', 'Ejecución', 'Vencido', 'Cerrado'],
    payloadDefault: {
        company_id: null,
        source_module: null,
        slq_location_id: null,
        status: null,
        wor_worker_id: null,
        implement_percentage: null,
        date_report: null,
        closing_date: null,
        description: '',
        improvement_options: null,
        legislation: null,
        concept: null,
        files: [],
        type: null,
    },
    grm_chart: [],
    modal_import: {
        show: false
    },
    findings: [],
    company: '',
    location: '',
    filter_findings: {
        company_id: null,
        slq_location_id: null,
        page: 1,
        per_page: 5
    },

}
